/**
* AUTOGENERATED FILE - DO NOT EDIT! LAST UPDATED ON 2026-04-20 @ 15:49 UTC
* TS VERSION: 5.9.3
**/

import { Socket, SocketRequestOf } from 'Src/models/socket';
import { SocketSvcBase } from 'Src/models/SocketSvcBase';
import type { operations } from 'Src/vendor/posapi/provisioner';

type SocketRequestParamOf<T extends { parameters: { body: { action: string; } } }> = Omit<T['parameters']['body'], 'action'>;
type SocketRequestOptions = { timeoutMilli: number };

class AutomatedCoreService extends SocketSvcBase {
  constructor(s: Socket) {
    super(s);
  }

  ['PROVISIONER:Login'] = (r: SocketRequestParamOf<operations['provisioner-socket-login']>, options?: SocketRequestOptions) => {
    const req = new SocketRequestOf('PROVISIONER:Login', r);
    return this.sendOnReady(req, undefined, options?.timeoutMilli) as Promise<operations['provisioner-socket-login']['responses'][200]['schema']>;
  };

  ['Logout'] = (r: SocketRequestParamOf<operations['all-socket-logout']>, options?: SocketRequestOptions) => {
    const req = new SocketRequestOf('Logout', r);
    return this.sendOnReady(req, undefined, options?.timeoutMilli) as Promise<void>;
  };

  ['GET:PasswordEmail'] = (r: SocketRequestParamOf<operations['all-socket-pw-reset-trigger']>, options?: SocketRequestOptions) => {
    const req = new SocketRequestOf('GET:PasswordEmail', r);
    return this.sendOnReady(req, undefined, options?.timeoutMilli) as Promise<void>;
  };

  ['POST:PasswordEmail'] = (r: SocketRequestParamOf<operations['all-socket-pw-reset-completion']>, options?: SocketRequestOptions) => {
    const req = new SocketRequestOf('POST:PasswordEmail', r);
    return this.sendOnReady(req, undefined, options?.timeoutMilli) as Promise<void>;
  };

  ['PROVISIONER:GET:Locations.WithTerminals'] = (r: SocketRequestParamOf<operations['provisioner-socket-get-locs-terms']>, options?: SocketRequestOptions) => {
    const req = new SocketRequestOf('PROVISIONER:GET:Locations.WithTerminals', r);
    return this.sendOnReady(req, undefined, options?.timeoutMilli) as Promise<operations['provisioner-socket-get-locs-terms']['responses'][200]['schema']>;
  };

  ['PROVISIONER:GET:Organizations'] = (r: SocketRequestParamOf<operations['provisioner-socket-get-all-orgs']>, options?: SocketRequestOptions) => {
    const req = new SocketRequestOf('PROVISIONER:GET:Organizations', r);
    return this.sendOnReady(req, undefined, options?.timeoutMilli) as Promise<operations['provisioner-socket-get-all-orgs']['responses'][200]['schema']>;
  };

  ['PROVISIONER:GET:Terminal'] = (r: SocketRequestParamOf<operations['provisioner-socket-terminal-claim']>, options?: SocketRequestOptions) => {
    const req = new SocketRequestOf('PROVISIONER:GET:Terminal', r);
    return this.sendOnReady(req, undefined, options?.timeoutMilli) as Promise<operations['provisioner-socket-terminal-claim']['responses'][200]['schema']>;
  };

  ['PROVISIONER:POST:Terminal.ProvisionToken'] = (r: SocketRequestParamOf<operations['provisioner-socket-terminal-provision']>, options?: SocketRequestOptions) => {
    const req = new SocketRequestOf('PROVISIONER:POST:Terminal.ProvisionToken', r);
    return this.sendOnReady(req, undefined, options?.timeoutMilli) as Promise<operations['provisioner-socket-terminal-provision']['responses'][200]['schema']>;
  };

  ['PROVISIONER:DELETE:Terminal.ProvisionToken'] = (r: SocketRequestParamOf<operations['provisioner-socket-terminal-unprovision']>, options?: SocketRequestOptions) => {
    const req = new SocketRequestOf('PROVISIONER:DELETE:Terminal.ProvisionToken', r);
    return this.sendOnReady(req, undefined, options?.timeoutMilli) as Promise<void>;
  };

}

export { AutomatedCoreService };
